import React from "react";

function NotFoundPage(props) {
  return <div></div>;
}

export default NotFoundPage;
